import React from 'react'
import cx from 'classnames'
import Link from 'next/link'

import s from './TopMenuItem.module.css'

const TopMenuItem = ({ data, isSelected, url }) => {
  const activeTabClass = cx(s.tab, {
    [s['tab--active']]: isSelected
  })

  return (
    <Link href={url} shallow scroll>
      <li className={activeTabClass}>
        <a className={s.link}>
          {data.icon && (
            <img className={s.listImg} src={data.icon} alt={data.name} />
          )}
          <div className={s.itemName}>{data.name}</div>
        </a>
      </li>
    </Link>
  )
}

export default TopMenuItem
